import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://lpnbbqwyomngcfppkpdo.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxwbmJicXd5b21uZ2NmcHBrcGRvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg3OTUxNzQsImV4cCI6MjA2NDM3MTE3NH0.DM74wUG9EPRHCK8K4giJr94lNIZ3z-C2cpk3hFaJmok'

export const supabase = createClient(supabaseUrl, supabaseKey)